
import {
  ExerciseModuleMap,
  ExerciseMutations,
} from "@/store/modules/exercise/types";
import { TimeoutReturn } from "@/types/timeout";
import { defineComponent } from "vue";
import { RouteRecordName } from "vue-router";
import { mapState } from "vuex";
import ButtonVue from "../ui/Button.vue";
import CounterVue from "./counter/Counter.vue";
import FooterVue from "./Footer.vue";
import HeaderVue from "./Header.vue";
import LungsVue from "./counter/Lungs.vue";
import LeaveExerciseConfirmVue from "./LeaveExerciseConfirm.vue";
import MixinLeaveExerciseVue from "./MixinLeaveExercise.vue";
import StartTipVue from "./StartTip.vue";
import { StoreState } from "@/store/types";
import { namespaceName } from "@/store/createStore";

const exerciseStateProps = [
  "breathTime",
  "breathsPerRound",
  "started",
  "disableAnimation",
  "disableStartTips",
] as const;

type ComputedTypes = ExerciseModuleMap<typeof exerciseStateProps>;

let breathTiemout: TimeoutReturn;
let startTipTimeout: TimeoutReturn = void 0;

export default defineComponent({
  name: "BreathingExercise-Breathing",
  mixins: [MixinLeaveExerciseVue],
  components: {
    appButton: ButtonVue,
    appLungs: LungsVue,
    appCounter: CounterVue,
    appLeaveExerciseConfirm: LeaveExerciseConfirmVue,
    appExerciseHeader: HeaderVue,
    appExerciseFooter: FooterVue,
    appStartTip: StartTipVue,
  },
  data() {
    return {
      counter: 1,
      countingFinished: false,
      showStartTip: true,
    };
  },
  computed: {
    ...(mapState<StoreState>("exercise", exerciseStateProps) as ComputedTypes),
  },

  watch: {
    showModal(val) {
      if (!val && this.countingFinished) {
        this.$router.replace({
          name: "BreathingExercise-BreathHold",
        });
      }
    },
  },

  methods: {
    count() {
      breathTiemout = setTimeout(this.breath, this.breathTime);
    },
    breath() {
      // @TODO: #9 counter goes beyond breathsPerRound if the leave dialog is displayed
      this.counter++;
      if (this.counter <= this.breathsPerRound) {
        breathTiemout = setTimeout(this.breath, this.breathTime);
        return;
      }
      this.nextScreen();
    },

    nextScreen() {
      if (breathTiemout) {
        clearTimeout(breathTiemout);
        breathTiemout = void 0;
      }
      this.countingFinished = true;
      this.$router.replace({
        name: "BreathingExercise-BreathHold",
      });
    },
  },
  beforeRouteLeave(to) {
    if (this.showModal && !this.allowNavigation) {
      return false;
    }

    if (to.name === "BreathingExercise-BreathHold") {
      clearTimeout(breathTiemout);
      breathTiemout = void 0;
      return true;
    }
    if (to.params.allowNavigation) {
      clearTimeout(breathTiemout);
      breathTiemout = void 0;
      return true;
    }
    this.askBeforeLeave(to.name as RouteRecordName);

    return false;
  },
  beforeMount() {
    this.showStartTip = !this.disableStartTips;
    if (!this.started) {
      this.$store.commit(namespaceName("exercise", ExerciseMutations.Start));
    }
  },
  mounted() {
    if (!this.showStartTip) {
      this.count();
      return;
    }

    startTipTimeout = setTimeout(() => {
      startTipTimeout = void 0;
      this.showStartTip = false;
      this.count();
    }, this.breathTime);
  },
  beforeUnmount() {
    if (startTipTimeout) {
      clearTimeout(startTipTimeout);
      startTipTimeout = void 0;
    }
  },
});
